import { type RefObject, type ReactNode } from 'react'
import { UAParser } from 'ua-parser-js'
import { Option } from '@/features/shared/components/Dropdown/Option'
import { DesktopDropdown } from '@/features/shared/components/Dropdown/DesktopDropdown'
import { MobileDropdown } from '@/features/shared/components/Dropdown/MobileDropdown'
import { ClientOnly } from '@/features/shared/components/ClientOnly'

export { Option }

type Props = {
  className?: string
  isOpen: boolean
  onChange: (value: string) => void
  onClose: () => void
  value: string | number
  buttonRef: RefObject<HTMLButtonElement | null>
  isScrollable?: boolean
  children: ReactNode
}

export const Dropdown = ({ children, isOpen, isScrollable, ...restProps }: Props) => {
  return (
    // we are using UAParser to detect the device type and render the appropriate dropdown component
    // (MobileDropdown or DesktopDropdown) based on whether the user is on a mobile device or not.
    // the ClientOnly component ensures that this logic only runs on the client side, preventing any
    // server side rendering issues related to device detection.
    <ClientOnly>
      {new UAParser().getDevice().type === 'mobile' ? (
        <MobileDropdown {...restProps}>{children}</MobileDropdown>
      ) : (
        <DesktopDropdown {...restProps} isOpen={isOpen} isScrollable={isScrollable}>
          {children}
        </DesktopDropdown>
      )}
    </ClientOnly>
  )
}
